import React, { useState } from 'react'

import TextField from '@mui/material/TextField'
import { styled } from '@mui/material/styles'

const Container = styled('form')({
  display: 'flex',
  flexWrap: 'wrap',
})

const StyledTextField = styled(TextField)({
  width: 380,
})

export default function HoursField(props) {
  function onChange(e) {
    if (props.onChange) {
      props.onChange(e.currentTarget.value)
    }
  }

  return (
    <Container noValidate>
      <StyledTextField
        id={props.id}
        label={props.label}
        onChange={onChange}
        type='time'
        value={props.initialValues ? props.initialValues : null}
        slotProps={{
          inputLabel: { shrink: true },
          htmlInput: { step: 300 }, // 5 min
        }}
        variant='outlined'
        inputVariant='outlined'
        style={{
          width: '100%',
        }}
      />
    </Container>
  )
}
